import api from '../api';

export default function Logout() {
  api.logOut();
  return (
    <></>
  );
}
